import React from "react";
import moment from "moment";

import styles from "./PreviewV3.module.css";

const getName = (signOff = {}) => signOff.staff_name || "";
const getRole = (signOff = {}) => signOff.job_title || "";
const getPhone = (signOff = {}) => signOff.phone_number || "";

const getHeading = (swmsData = {}) => {
  const headingContents = swmsData
    && swmsData.meta
    && Array.isArray(swmsData.meta.heading_contents)
    ? swmsData.meta.heading_contents
    : [];
  const heading = headingContents.find((item) => item && item.heading_key === "swms_staff_signoff");
  return heading && typeof heading.heading_content === "string"
    ? heading.heading_content
    : null;
};

export default function SwmsSignOffSection({
  swmsData = {},
  staffSignOff = [],
  sectionNumber
}) {
  const signOffs = Array.isArray(staffSignOff) ? staffSignOff : [];
  const heading = getHeading(swmsData);

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        {sectionNumber ? (
          <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`}>
            {sectionNumber}
          </span>
        ) : null}
        SWMS Sign Off
      </div>
      <div className={styles.PreviewSectionBody}>
        {heading ? (
          <div className={`${styles.PreviewRichText} preview-swms-v3-authorization-rich-text`} dangerouslySetInnerHTML={{ __html: heading }} />
        ) : null}
        <table className={styles.PreviewTable}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Role</th>
              <th>Phone</th>
              <th>Signature</th>
            </tr>
          </thead>
          <tbody>
            {signOffs.length > 0 ? signOffs.map((signOff, index) => {
              const signature = signOff.staff_sign || "";
              return (
                <tr key={`${signOff.staff_id || signOff.staff_name || "signoff"}-${index}`}>
                  <td>{signOff.sign_off_date ? moment.utc(signOff.sign_off_date).format("DD/MM/YYYY") : <span>&mdash;</span>}</td>
                  <td><strong>{getName(signOff) || <span>&mdash;</span>}</strong></td>
                  <td style={{ textTransform: "capitalize" }}>{getRole(signOff) || <span>&mdash;</span>}</td>
                  <td>{getPhone(signOff) || <span>&mdash;</span>}</td>
                  <td>
                    {signature ? <img style={{ maxWidth: "auto", objectFit: "contain", maxHeight: "20px" }} src={signature} alt="Signature" /> : <span>&mdash;</span>}
                  </td>
                </tr>
              );
            }            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}
